<template>
    <div class="home">
        <div class="top-white-box"></div>

        <div class="black-friday-banner" v-if="settings.homepageBanner && settings.purimMode">
            <img src="/Assets/img/purim.jpg">
        </div>
        <div class="black-friday-banner" v-else-if="settings.homepageBanner && settings.siteName != 'mommydeals'">
            <img :src="settings.homepageBanner">
        </div>


        <div class="top-gray-box" v-else>
            <h1>Latest Deals</h1>
        </div>

        <!--<GiveawayBox />-->
        <Deals showJoinUs="true" />

    </div>
</template>

<script>
    // @ is an alias to /src
    import Deals from '@/components/Deals.vue'
    //import GiveawayBox from '@/components/GiveawayBox.vue'
    import settings from '@/settings'

    export default {
        name: 'home',
        data() {
            return {
                fafa: false
            }
        },
        created() {
            //document.title = settings.siteNameCaps + ' | Great Deals on Household Items';
        },
        computed: {
            settings: function () { return settings; },
        },
        components: {
            Deals,
            //GiveawayBox
        }
    }
</script>